/**
 * A function to abstract React + Redux app initialization
 * This should be used in the top level (index.js) file
 * Sets up dev tools, Redux store + middleware, Router and entry component
 */

import React from 'react'
import { render } from 'react-dom'
import { Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore, compose } from 'redux'
import {setAppElement} from "components/modal"

const initializeApp = ({
  reducer,
  reduxMiddleware,
  App,
  Router, 
  rootId = 'app',
  beforeRender = () => {},
}) => {
  let storeEnhancers = applyMiddleware(reduxMiddleware)
  //let devTools

  // if (process.env.NODE_ENV === 'development') {
  //   const DevTools = require('components/controls/dev-tools').default // eslint-disable-line global-require
  //   storeEnhancers = compose(storeEnhancers, DevTools.instrument())
  //   devTools = <DevTools />
  // }

  const store = createStore(reducer, storeEnhancers)

  beforeRender()
  setAppElement(`#${rootId}`)

  render(
    <Provider store={store}>
      <Router>
        <div>
          {/* {devTools} */}
          <Route path="/" component={App} />
        </div>
      </Router>
    </Provider>,
    document.getElementById(rootId)
  )

  return {
    store,
  }
}

export default initializeApp
